import { useEffect, useRef, useMemo } from 'react';
class UseSafeError extends Error {
    isCanceled;
    constructor(message) {
        super(message);
        this.isCanceled = true;
    }
}
export function wrapSafePromise(promise) {
    let isCanceled = false;
    const wrappedPromise = new Promise((resolve, reject) => {
        promise
            .then(val => !isCanceled
            ? resolve(val)
            : reject(new UseSafeError()))
            .catch(err => !isCanceled
            ? reject(err)
            : reject(new UseSafeError()));
    });
    return {
        promise: wrappedPromise,
        cancel: () => { isCanceled = true; },
    };
}
export function useMakeSafePromise(dispatch) {
    const promises = useRef([]);
    const isMounted = useRef(false);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
            promises.current?.forEach(p => p.cancel());
        };
    }, []);
    const makeSafeMemo = useMemo(() => {
        function makeSafe(p) {
            if (!p)
                return;
            // If this is a normal function, simply return the value
            if (typeof p.then !== 'function') {
                return p;
            }
            const safePromise = wrapSafePromise(p);
            promises.current.push(safePromise);
            return safePromise.promise;
        }
        return makeSafe;
    }, []);
    const safeDispatchMemo = useMemo(() => {
        function safeDispatch(v) {
            if (isMounted.current && dispatch) {
                return dispatch(v);
            }
        }
        return safeDispatch;
    }, []);
    return {
        makeSafe: makeSafeMemo,
        safeDispatch: safeDispatchMemo,
        isMounted: isMounted,
    };
}
export default useMakeSafePromise;
//# sourceMappingURL=useSafePromise.js.map